import { createSlice } from '@reduxjs/toolkit';
import { stockIntegrationsApi } from 'api';

export const groupDifferenceSlice = createSlice({
    name: 'groupDifference',
    initialState: {
        pending: false,
        error: null,
        items: [],
        total: 0,
        count: 0,
        currentPage: 1,
        totalPages: 1,
    },
    reducers: {
        start: (state) => {
            state.pending = true;
            state.error = null;
        },
        stop: (state) => {
            state.pending = false;
        },
        setError: (state, action) => {
            state.pending = false;
            state.error = action.payload;
        },
        setGroupDifferences: (state, action) => {
            state.pending = false;
            state.items = action.payload.items || [];
            state.total = Number(action.payload.total || 0);
            state.currentPage = Number(action.payload.page || 1);
            state.totalPages = Number(action.payload.totalPages || 1);
        },
        setGroupDifferenceCount: (state, action) => {
            state.count = Number(action.payload || 0);
        },
    },
});

export const { start, stop, setError, setGroupDifferences, setGroupDifferenceCount } = groupDifferenceSlice.actions;

export const getGroupDifferences = (state) => state.groupDifference.items;
export const getGroupDifferencesPending = (state) => state.groupDifference.pending;
export const getGroupDifferencesTotal = (state) => state.groupDifference.total;
export const getGroupDifferencesCurrentPage = (state) => state.groupDifference.currentPage;
export const getGroupDifferencesTotalPages = (state) => state.groupDifference.totalPages;
export const getGroupDifferencesCount = (state) => state.groupDifference.count;

export const fetchGroupDifferencesAction =
    ({ organizationId, page = 1, limit = 10, entityType = 'user-group', onSuccess, onFailure } = {}) =>
    async (dispatch) => {
        if (!organizationId) {
            return;
        }

        try {
            dispatch(start());
            const { data } = await stockIntegrationsApi.get(`organizations/${organizationId}/entity-differences`, {
                params: {
                    entityType,
                    page,
                    limit,
                },
            });

            dispatch(setGroupDifferences(data || { items: [], total: 0, page, totalPages: 1 }));
            onSuccess?.(data);
        } catch (error) {
            dispatch(setError(error));
            onFailure?.(error);
        }
    };

export const fetchGroupDifferencesCountAction =
    ({ organizationId, entityType = 'user-group', onSuccess, onFailure } = {}) =>
    async (dispatch) => {
        if (!organizationId) {
            return;
        }

        try {
            const { data } = await stockIntegrationsApi.get(`organizations/${organizationId}/entity-differences/count`, {
                params: { entityType },
            });
            dispatch(setGroupDifferenceCount(data || 0));
            onSuccess?.(data);
        } catch (error) {
            dispatch(setError(error));
            onFailure?.(error);
        }
    };

export const confirmGroupDifferenceAction =
    ({ organizationId, differenceId, onSuccess, onFailure } = {}) =>
    async (dispatch) => {
        if (!organizationId || !differenceId) {
            return;
        }

        try {
            await stockIntegrationsApi.patch(
                `organizations/${organizationId}/entity-differences/${differenceId}/confirm`,
            );

            if (organizationId) {
                dispatch(
                    fetchGroupDifferencesCountAction({
                        organizationId,
                        entityType: 'user-group',
                    }),
                );
            }

            onSuccess?.();
        } catch (error) {
            dispatch(setError(error));
            onFailure?.(error);
        }
    };

export default groupDifferenceSlice.reducer;
